import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SsPermissionControlDirective } from '@blocks/permission/ss-permission-control.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [SsPermissionControlDirective],
  exports: [SsPermissionControlDirective],
})
export class SsPermissionModule {}
